// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .module-icon[data-v-50c988ce]{margin-top:1px}", ""]);
// Exports
module.exports = exports;
